import { Box, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  padding: 0 24px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 24px;
    max-width: 500px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 120px; max-width: 100%' : 'padding: 0 24px; max-width: 500px')};
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: auto;
  min-width:328px;
`
